import { render, staticRenderFns } from "./LayoutAuthForm.vue?vue&type=template&id=68fe9ff9&scoped=true&"
import script from "./LayoutAuthForm.vue?vue&type=script&lang=js&"
export * from "./LayoutAuthForm.vue?vue&type=script&lang=js&"
import style0 from "./LayoutAuthForm.vue?vue&type=style&index=0&id=68fe9ff9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fe9ff9",
  null
  
)

export default component.exports